import { namespace } from './namespace';

export const UPDATE_ZIPCODE = namespace + '/UPDATE_ZIPCODE';
export const VALIDATE_ZIPCODE = namespace + '/VALIDATE_ZIPCODE';
export const DISPLAY_ERROR = namespace + '/DISPLAY_ERROR';
export const SAVE_ZIPCODE = namespace + '/SAVE_ZIPCODE';
